import { FloraTextarea, FloraTextareaProps } from '..'

/**
 * @deprecated Esta tipagem refere-se a um componente que será descontinuado em futuras Breaking Changes do Flora.
 * @tutorial
 * {@link https://florabook.gb.tech/v2/index.html?path=/docs/core-components-florabutton-guia-de-migra%C3%A7%C3%A3o--page| Acesse o guia de migração} para saber como migrar para a nova versão.
 */
export type TextareaProps = FloraTextareaProps

/**
 * @deprecated Este componente será descontinuado em futuras Breaking Changes do Flora.
 * @tutorial
 * {@link https://florabook.gb.tech/v2/index.html?path=/docs/core-components-florabutton-guia-de-migra%C3%A7%C3%A3o--page| Acesse o guia de migração} para saber como migrar para a nova versão.
 */
export const Textarea = FloraTextarea
